import { Flex, Layout } from "antd";
import { FC } from "react";
import {
    AssignmentResponseType,
    Market,
    TaskAssignment,
    TaskStatus,
} from "tm-shared/types";

import { AssignmentTaskInfo } from "@/components/AssignmentTaskInfo";
import { SubtaskCard } from "@/components/TasksModals/components/SubtaskCard";
import { ASSIGNMENT_VOCABULARY } from "@/constants/ui/assignment";

import { CustomTaskFromTaskButton } from "../components/CustomTaskFromTaskButton";
import { TaskViewModal } from "../TaskViewModal";

interface AssignmentViewModalProps {
    market: Market;
    task: TaskAssignment;
    onClose: () => void;
}

export const AssignmentViewModal: FC<AssignmentViewModalProps> = ({
    market,
    task,
    onClose,
}) => {
    const taskPayload = task.payload;
    const completedAt = task?.completedAt;

    if (!taskPayload || !completedAt) return null;

    const assignmentType = task.context.additionalData.assignmentType;
    const assignmentLabel = ASSIGNMENT_VOCABULARY[assignmentType]?.label;
    const taskImages = [
        ...(task?.context?.files?.length ? task.context.files : []),
        ...(taskPayload?.photos?.length ? taskPayload.photos : []),
    ];

    let title;

    if (task.context.responseType === AssignmentResponseType.Bool) {
        title = `Результат виконання: ${
            taskPayload.status === TaskStatus.Completed ? "Так" : "Ні"
        }`;
    }

    return (
        <TaskViewModal title={task.name} onClose={onClose} taskInfo={task.info}>
            <Flex vertical gap={16}>
                <CustomTaskFromTaskButton
                    task={task}
                    market={market}
                    images={taskImages}
                />
                <Layout style={{ padding: 16, borderRadius: 8 }}>
                    <AssignmentTaskInfo
                        assignmentType={assignmentLabel}
                        description={task.context.description}
                        images={task.context.files}
                    />
                </Layout>

                <SubtaskCard subtask={taskPayload} title={title} />
            </Flex>
        </TaskViewModal>
    );
};
